import type { ReactNode } from "react";

type Props = {
  title: string;
  children: ReactNode;
  /**
   * Body width. "readable" (default) caps the content at 720px — right for
   * forms and value-action cards (Account, Billing, API). "full" lets the
   * content fill the available settings column — for data-dense panels
   * (wide tables, multi-card grids) that read better edge-to-edge, e.g.
   * Company's Adv-Media + Accounts/SSO tabs. Default keeps every other
   * settings page byte-identical.
   */
  width?: "readable" | "full";
};

export function SectionPage({ title, children, width = "readable" }: Props) {
  return (
    <div className="flex w-full flex-col gap-4">
      <h2 className="text-h4 text-black">{title}</h2>
      <div className="h-px w-full bg-grey-200" />
      <div className={`flex w-full flex-col gap-2 ${width === "readable" ? "max-w-[720px]" : ""}`}>
        {children}
      </div>
    </div>
  );
}
